<div
	[ngClass]="{'bg-blue-400/20 rounded-r-lg': day.isToday}"
	[style.minHeight.px]="day.rowMinHeightPx"
	class="flex h-full min-h-0 flex-row items-stretch pl-2"
>
	<div class="flex flex-1 self-stretch flex-col items-stretch gap-1 xl:gap-2">
		@if (enabledTimes.projecthoursEnabled) {
		<div class="mt-2 flex min-h-0 w-full flex-1 items-center justify-end xl:mt-3">
			<span class="font-semibold"> &nbsp;{{ (day.projecthoursTimes.totalTime | parseMsAsDuration) }} </span>
		</div>
		} @if (enabledTimes.workinghoursEnabled) {
		<div class="mb-2 flex min-h-0 flex-1 items-center xl:mb-3">
			@if (day.workinghoursTimes.schedule; as sched) {
			<span
				[class.text-green-600]="sched.usage > sched.cap"
				[class.text-red-600]="sched.usage < sched.cap"
				class="w-full flex flex-row items-center justify-end"
			>
				@if (sched.usage - sched.cap == 0 && sched.cap > 0) {
				<mat-icon>check</mat-icon>
				} @else {
				<span>
					{{ sched.usage - sched.cap > 0 ? '+' : '-' }}
					{{ (sched.usage - sched.cap | parseMsAsDuration: false : false ) }}
				</span>
				}
			</span>
			}
		</div>
		}
	</div>
	<div class="mb-2 flex flex-1 self-stretch flex-col items-stretch gap-1 xl:mb-3 xl:gap-2">
		@if (enabledTimes.projecthoursEnabled) {
		<div class="mt-2 flex min-h-0 flex-1 items-center xl:mt-3"></div>
		} @if (enabledTimes.workinghoursEnabled && day.workinghoursTimes.violations.length > 0) {
		<div
			[matTooltipTemplate]="whErrorTooltip"
			[matTooltipTemplateContext]="{ errors: day.workinghoursTimes.violations }"
			class="flex min-h-0 flex-1 items-center  justify-center"
			matTooltip
		>
			<mat-icon color="accent">warning</mat-icon>
		</div>
		}
	</div>
</div>

<ng-template
	#whErrorTooltip
	let-errors="errors"
>
	<div class="flex flex-col space-y-2">
		@for (werr of errors; track werr.message) {
		<div class="flex items-start space-x-2">
			<div class="flex flex-col gap-2">
				<div class="dot mt-1.5 mat-size-1.5"></div>
				@if (werr.count) {
				<div class="text-sm font-medium leading-4 align-middle">x{{ werr.count }}</div>
				}
			</div>
			<div>{{ werr.message | translate: (werr.args | translateArgs) }}</div>
		</div>
		}
	</div>
</ng-template>
